import { render, staticRenderFns } from "./contentsList.vue?vue&type=template&id=3e8e0d8e"
import script from "./contentsList.vue?vue&type=script&lang=ts"
export * from "./contentsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports